import React, { useContext } from "react";

import { css } from "@emotion/react";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../../context";

export const LockedBreakpoint4 = () => {
  const { theme } = useContext(DiscountProgressBarContext);

  const circleClass = css`
    fill: ${theme.breakpoint.inactiveColor};
    stroke: ${theme.breakpoint.inactiveColor};
  `;

  const pathClass = css`
    fill: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.breakpoint.inactiveColorKey
      )
    )};
  `;

  return (
    <span
      className={"ig-dp-locked-breakpoint"}
      css={css`
        display: block;
      `}
    >
      <svg width={28} height={28} fill="none" viewBox="0 0 88 88">
        <path
          d="m87.498 43.799-7.488-9.766 1.674-12.134-11.429-4.538-4.532-11.442-12.121 1.676L43.749 0l-9.755 7.497-12.12-1.677-4.533 11.443L5.912 21.8l1.674 12.135L0 43.799l7.488 9.767L5.814 65.7l11.429 4.537 4.532 11.443 12.121-1.677 9.755 7.497 9.755-7.497 12.12 1.677 4.533-11.443 11.429-4.636-1.674-12.134 7.686-9.668h-.002Z"
          css={circleClass}
        />
        <path
          d="M30.225 62.781a2.988 2.988 0 0 1-2.211-.924c-.608-.615-.911-1.363-.911-2.242V36.72c0-.879.303-1.626.911-2.242a2.988 2.988 0 0 1 2.211-.924h3.641V28.49c0-2.777.962-5.144 2.887-7.094 1.925-1.952 4.257-2.927 6.997-2.927 2.739 0 5.074.975 6.997 2.927 1.925 1.952 2.886 4.317 2.886 7.094v5.064h3.642c.867 0 1.604.308 2.211.924.607.616.911 1.363.911 2.242v22.895c0 .879-.304 1.627-.911 2.242a2.988 2.988 0 0 1-2.211.924H30.221h.004Zm6.764-29.225h13.527v-5.064c0-1.898-.66-3.516-1.978-4.852-1.318-1.336-2.913-2.005-4.786-2.005-1.872 0-3.468.669-4.785 2.005-1.318 1.336-1.978 2.954-1.978 4.852v5.064Zm-6.764 26.059h27.054V36.72H30.225v22.895Zm13.527-7.386c1.109 0 2.055-.386 2.836-1.16.781-.774 1.171-1.707 1.171-2.795 0-1.089-.39-2.015-1.171-2.876-.781-.861-1.725-1.292-2.836-1.292-1.109 0-2.055.431-2.836 1.292-.781.861-1.171 1.82-1.171 2.876 0 1.055.39 2.021 1.171 2.795s1.725 1.16 2.836 1.16Z"
          css={pathClass}
        />
      </svg>
    </span>
  );
};
